export default __webpack_public_path__ + "static/media/yaml-icon.e4298665.svg";